import { Config } from '@adornis/config/config.js';

export const projectConfig = new Config('ChancenWerk', {
  UMGEBUNG: { env: true, required: true, client: true, name: 'UMGEBUNG' },
  CAMPUS_URL: { env: true, required: true, client: true, name: 'CAMPUS_URL' },
  RAUM_URL: { env: true, required: true, client: true, name: 'RAUM_URL' },
  ANMELDUNG_URL: { env: true, required: false, client: true, name: 'ANMELDUNG_URL', defaultVal: '' },
  LOGISTIK_URL: { env: true, required: true, client: true, name: 'LOGISTIK_URL' },
  NETZ_URL: { env: true, required: true, client: true, name: 'NETZ_URL' },
  BOARD_URL: { env: true, required: true, client: true, name: 'BOARD_URL' },
  KRAEFTE_URL: { env: true, required: true, client: true, name: 'KRAEFTE_URL' },
  HEFTE_URL: { env: true, required: true, client: true, name: 'HEFTE_URL' },
  AKADEMIE_URL: { env: true, required: false, client: true, name: 'AKADEMIE_URL', defaultVal: '' },
  MARKT_URL: { env: true, required: false, client: true, name: 'MARKT_URL', defaultVal: '' },
  FAMILY_URL: { env: true, required: false, client: true, name: 'FAMILY_URL', defaultVal: '' },
  EPUB_URL: { env: true, required: false, client: true, name: 'EPUB_URL', defaultVal: '' },
  OAUTH_CLIENT_ID: {
    env: true,
    required: true,
    client: true,
    name: 'OAUTH2_CLIENT_ID',
    // OAuth client id is not a secret per se, as it is used in the client to initiate the OAuth flow
    yesICheckedThatThisISActuallyNotASecretEnvVarAndShouldBeExposedToTheClientIWillNotBeDecapitatedByTheAdornisTeam: true,
  },
  POSTMARK_SERVER_TOKEN: { env: true, required: true, client: false, name: 'POSTMARK_SERVER_TOKEN' },
  CAMPUS_SECRET: { env: true, required: false, client: false, name: 'CAMPUS_SECRET', defaultVal: 'secret' },
  RAUM_SECRET: { env: true, required: false, client: false, name: 'RAUM_SECRET', defaultVal: 'secret' },
  LOGISTIK_SECRET: { env: true, required: false, client: false, name: 'LOGISTIK_SECRET', defaultVal: 'secret' },
  NETZ_SECRET: { env: true, required: false, client: false, name: 'NETZ_SECRET', defaultVal: 'secret' },
  BOARD_SECRET: { env: true, required: false, client: false, name: 'BOARD_SECRET', defaultVal: 'secret' },
  KRAEFTE_SECRET: { env: true, required: false, client: false, name: 'KRAEFTE_SECRET', defaultVal: 'secret' },
  HEFTE_SECRET: { env: true, required: false, client: false, name: 'HEFTE_SECRET', defaultVal: 'secret' },
  AKADEMIE_SECRET: { env: true, required: false, client: false, name: 'AKADEMIE_SECRET', defaultVal: 'secret' },
  MARKT_SECRET: { env: true, required: false, client: false, name: 'MARKT_SECRET', defaultVal: 'secret' },
  FAMILY_SECRET: { env: true, required: false, client: false, name: 'FAMILY_SECRET', defaultVal: 'secret' },
  EPUB_SECRET: { env: true, required: false, client: false, name: 'EPUB_SECRET', defaultVal: 'secret' },
  INVOKE_PERMISSION_SYNC_ON_START: {
    env: true,
    required: false,
    client: false,
    name: 'INVOKE_PERMISSION_SYNC_ON_START',
    defaultVal: 'false',
  },
  INVOKE_INACTIVE_STUDENTS_ANALYTICS_ON_START: {
    env: true,
    required: false,
    client: false,
    name: 'INVOKE_INACTIVE_STUDENTS_ANALYTICS_ON_START',
    defaultVal: 'false',
  },
  INVOKE_DELETE_BLANKO_ACCOUNTS_ON_START: {
    env: true,
    required: false,
    client: false,
    name: 'INVOKE_DELETE_BLANKO_ACCOUNTS_ON_START',
    defaultVal: 'false',
  },
  INVOKE_WORKSHOP_REMINDER_ON_START: {
    env: true,
    required: false,
    client: false,
    name: 'INVOKE_WORKSHOP_REMINDER_ON_START',
    defaultVal: 'false',
  },
  INVOKE_WORKSHOP_STATE_UPDATE_ON_START: {
    env: true,
    required: false,
    client: false,
    name: 'INVOKE_WORKSHOP_STATE_UPDATE_ON_START',
    defaultVal: 'false',
  },
  INVOKE_SEND_NOTIFICATION_EMAILS: {
    env: true,
    required: false,
    client: false,
    name: 'INVOKE_SEND_NOTIFICATION_EMAILS',
    defaultVal: 'false',
  },
  INVOKE_FIX_PRESENCE_ON_START: {
    env: true,
    required: false,
    client: false,
    name: 'INVOKE_FIX_PRESENCE_ON_START',
    defaultVal: 'false',
  },
  INVOKE_MARK_STALE_SENT_ORDERS_AS_DONE: {
    env: true,
    required: false,
    client: false,
    name: 'INVOKE_MARK_STALE_SENT_ORDERS_AS_DONE',
    defaultVal: 'false',
  },
  OPENAI_API_KEY: { env: true, required: false, client: false, name: 'OPENAI_API_KEY', defaultVal: '' },
  SOFTGARDEN_TOKEN: { env: true, required: false, client: false, name: 'SOFTGARDEN_TOKEN', defaultVal: '' },
  SOFTGARDEN_PUBLIC_ID: { env: true, required: false, client: false, name: 'SOFTGARDEN_PUBLIC_ID', defaultVal: '' },
  AMDIN_PASS: { env: true, required: false, client: false, name: 'AMDIN_PASS', defaultVal: 'Test123*' },

  ADDRESS_GOOGLE_API_KEY: { env: true, required: false, client: false, name: 'ADDRESS_GOOGLE_API_KEY', defaultVal: '' },

  /**
   * set to anything but '' to enable
   */
  FEATURE_PROTOKOLLE: { env: true, required: false, client: true, name: 'FEATURE_PROTOKOLLE', defaultVal: '' },
  FEATURE_EDITABLE_UI: { env: true, required: false, client: true, name: 'FEATURE_EDITABLE_UI', defaultVal: '' },
  FEATURE_VIDIS: { env: true, required: false, client: true, name: 'FEATURE_VIDIS', defaultVal: '' },

  SERVICE_NAME: { env: true, required: true, client: true, name: 'SERVICE_NAME' },
  MAT_VIEW_JOB_SPLIT: { env: true, required: false, client: false, name: 'MAT_VIEW_JOB_SPLIT', defaultVal: '30' },
  MAT_VIEW_THREADS: { env: true, required: false, client: false, name: 'MAT_VIEW_THREADS', defaultVal: '2' },

  DUPLICATE_SEARCH_MAX_THREADS: {
    env: true,
    required: false,
    client: false,
    name: 'DUPLICATE_SEARCH_MAX_THREADS',
    defaultVal: '4',
  },

  /**
   * Wiki settings
   */
  WIKI_CHUNK_SIZE: { env: true, required: false, client: false, name: 'WIKI_CHUNK_SIZE', defaultVal: '250' },

  /**
   * Release Notes
   */
  PLANIO_API_KEY: { env: true, required: false, client: false, name: 'PLANIO_API_KEY', defaultVal: '' },
});
